export function getFileStructure (file) {
  var fileReader = new FileReader();

  return new Promise((resolve, reject) => {
    fileReader.onerror = () => {
      fileReader.abort();

      reject(new Error('Error parsing file'));
    };

    fileReader.onload = ({ target: { result } }) => {
      resolve({
        dataUrl: result,
        name: file.name, 
        size: file.size,
        type: file.type
      });
    };

    fileReader.readAsDataURL(file);
  });
}

export function readJsonFile(file) {
  const fileReader = new FileReader();

  return new Promise((resolve, reject) => {
    fileReader.onerror = () => {
      fileReader.abort();

      reject(new Error('Error parsing file'));
    };

    fileReader.onload = ({ target: { result } }) => {
      try {
        resolve(JSON.parse(result));
      } catch (error) {
        reject(error);
      }
    };

    fileReader.readAsText(file);
  });
}

export function downloadObjectAsJson (exportObj, exportName) {
  const stringifyedData = encodeURIComponent(JSON.stringify(exportObj, null, 2));

  const dataStr = 'data:text/json;charset=utf-8,' + stringifyedData;

  const anchor = document.createElement('a');
  anchor.setAttribute('href',     dataStr);
  anchor.setAttribute('download', exportName + '.json');

  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
}